import React from 'react';
import { Hammer, Clock, DollarSign, CheckCircle } from 'lucide-react';

interface Quote {
  id: string;
  jobTitle: string;
  client: string;
  location: string;
  estimatedHours: number;
  materialsCost: number;
  laborCost: number;
  status: 'pending' | 'accepted' | 'declined' | 'in_progress';
  date: string;
}

const mockQuotes: Quote[] = [
  {
    id: '1',
    jobTitle: 'Kitchen Renovation',
    client: 'Sarah Johnson',
    location: '123 Main St, Sydney',
    estimatedHours: 40,
    materialsCost: 5000,
    laborCost: 3000,
    status: 'pending',
    date: '2024-03-15',
  },
  {
    id: '2',
    jobTitle: 'Bathroom Plumbing',
    client: 'Mike Smith',
    location: '456 Park Ave, Melbourne',
    estimatedHours: 16,
    materialsCost: 2000,
    laborCost: 1200,
    status: 'accepted',
    date: '2024-03-16',
  },
];

export function JobQuotes() {
  return (
    <div className="bg-white rounded-lg shadow">
      <div className="p-6 border-b border-gray-200">
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-semibold text-gray-900">Job Quotes</h2>
          <button className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors flex items-center gap-2">
            <Hammer className="h-4 w-4" />
            New Quote
          </button>
        </div>
      </div>
      <div className="p-6">
        <div className="space-y-4">
          {mockQuotes.map(quote => (
            <div key={quote.id} className="border rounded-lg p-4 hover:bg-gray-50">
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="text-lg font-medium text-gray-900">{quote.jobTitle}</h3>
                  <p className="text-sm text-gray-500">{quote.client}</p>
                  <p className="text-sm text-gray-500">{quote.location}</p>
                </div>
                <span
                  className={`px-2 py-1 text-xs font-semibold rounded-full
                  ${quote.status === 'accepted' ? 'bg-green-100 text-green-800' : ''}
                  ${quote.status === 'pending' ? 'bg-yellow-100 text-yellow-800' : ''}
                  ${quote.status === 'declined' ? 'bg-red-100 text-red-800' : ''}
                  ${quote.status === 'in_progress' ? 'bg-blue-100 text-blue-800' : ''}
                `}
                >
                  {quote.status.replace('_', ' ').charAt(0).toUpperCase() + quote.status.slice(1)}
                </span>
              </div>
              <div className="mt-4 grid grid-cols-3 gap-4">
                <div className="flex items-center gap-2">
                  <Clock className="h-4 w-4 text-gray-400" />
                  <span className="text-sm text-gray-600">{quote.estimatedHours}h</span>
                </div>
                <div className="flex items-center gap-2">
                  <DollarSign className="h-4 w-4 text-gray-400" />
                  <span className="text-sm text-gray-600">${quote.materialsCost}</span>
                </div>
                <div className="flex items-center gap-2">
                  <CheckCircle className="h-4 w-4 text-gray-400" />
                  <span className="text-sm text-gray-600">${quote.laborCost}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
